export const colorTheme = {
    background: "#ffffff",
    secondaryBackground: "#e8e6e5",
    title: "#000000",
    subtitles: "#000000",
    solidButtonBackground: "#0747a6",
    solidButtonLabel: "#ffffff",
    onlineButton: "#0747a6",
}